const isSystemStyle = (ps, styleId: string) => !!ps.extensionAPI.schemaAPI.isSystemStyle(styleId)

export default isSystemStyle
